import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=1d9905ab"
import script from "./FormHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FormHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=1d9905ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports